import { BaseDto } from "../common/baseDto";

export interface ProductOrderMaterialLotDto extends BaseDto {
  productOrderNo: string;
  itemCd: string;
  lotNo: string;
  lotSeq: number;
  orderDt: string | undefined;
  workplaceCd: string;
  lotQty: number;
  remark: string;
  inserted: boolean;
}

export const defaultProductOrderMaterialLotDto: ProductOrderMaterialLotDto = {
  valueIndex: 0,
  orderIndex: 0,
  orderIndexSeq: 0,
  productOrderNo: "",
  itemCd: "",
  lotNo: "",
  lotSeq: 0,
  orderDt: undefined,
  workplaceCd: "",
  lotQty: 0,
  remark: "",
  inserted: false,
};
